import PropTypes from 'prop-types';
import React from 'react';

import VoiceTrackIcon from '../../../../static/icons/ic_voicetrack_16.svg';
import { createBEM } from '../../../lib/utils/css';
import Icon from '../Icon';

import './VoiceIcon.scss';

const VoiceIcon = ({ isBackgroundDark }) => {
  const classes = createBEM('VoiceIcon', {
    darkBackground: isBackgroundDark,
  });

  return (
    <div className={classes}>
      <Icon glyph={VoiceTrackIcon} />
    </div>
  );
};

VoiceIcon.propTypes = {
  isBackgroundDark: PropTypes.bool,
};

export default VoiceIcon;
